import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, jsonLd }) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (!ld) return undefined;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.dataset.seo = "page";
    s.text = ld;
    document.head.appendChild(s);
    return () => s.remove();
  }, [title, description, ld]);
};
